<template>
  <nav class="fixed bottom-0 left-0 right-0 z-[9999] bg-gray-900 border-t border-gray-800 h-16" style="padding-bottom: env(safe-area-inset-bottom, 0px);">
  <div class="flex flex-1 justify-between items-center w-full h-full">
    <template v-for="item in filteredMenuItems" :key="item.name">
      <router-link
        :to="item.path"
        class="flex flex-col items-center justify-center flex-1 px-1 py-2 text-gray-300 hover:text-white transition-colors duration-150 text-xs"
        :class="{ 'text-indigo-400': $route.path === item.path }"
        style="min-width: 0;"
      >
        <span v-html="sanitizeHtml(item.icon)" class="h-6 w-6"></span>
      </router-link>
    </template>

    <!-- Bouton Mentions légales, toujours visible -->
    <button
      @click="$emit('open-legal')"
      aria-label="Mentions légales"
      class="flex flex-col items-center justify-center flex-1 px-1 py-2 text-gray-300 hover:text-white transition-colors duration-150 text-xs"
      style="min-width: 0;"
    >
      <span class="h-6 w-6" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M11.25 3.75a7.5 7.5 0 107.5 7.5 7.508 7.508 0 00-7.5-7.5zm0 13.5a6 6 0 116-6 6.006 6.006 0 01-6 6z"/><path d="M11.25 7.5a.75.75 0 01.75.75V12a.75.75 0 01-1.5 0V8.25a.75.75 0 01.75-.75zM11.25 13.5a.75.75 0 01.75.75v.75a.75.75 0 01-1.5 0v-.75a.75.75 0 01.75-.75z"/></svg>
      </span>
      <span title="Mentions légales">Mentions</span>
    </button>
  </div>
</nav>

</template>

<script>
import { defineComponent, computed } from 'vue'
import { menuItems } from '@/config/menuItems'
import { sanitizeHtml } from '@/utils/sanitizeHtml'

export default defineComponent({
  name: 'MobileNavBar',
  emits: ['open-legal'],
  setup() {
    // Filtre les éléments du menu pour mobile: masquer les éléments admin sur mobile pour gagner de l'espace
    const filteredMenuItems = computed(() =>
      menuItems
        .filter(item => !item.requiresAdmin)
        .map(item => ({
          path: item.path,
          name: item.name,
          icon: item.icon
        }))
    )
    return { filteredMenuItems, sanitizeHtml }
  }
})
</script>
